import script from "./ds-badge.vue?vue&type=script&lang=ts&setup=true&generic=T"
export * from "./ds-badge.vue?vue&type=script&lang=ts&setup=true&generic=T"

const __exports__ = script;

export default __exports__